export const LAKE_COMO_SOURCE_LOCALE = "en" as const;

export const LAKE_COMO_LOCALES = [
  {
    code: "en",
    label: "English",
    nativeLabel: "English",
    htmlLang: "en",
    dateLocale: "en-GB",
    enabledForTranslation: false,
    publiclyLaunched: true,
    isSource: true,
  },
  {
    code: "it",
    label: "Italian",
    nativeLabel: "Italiano",
    htmlLang: "it",
    dateLocale: "it-IT",
    enabledForTranslation: true,
    publiclyLaunched: false,
    isSource: false,
  },
  {
    code: "de",
    label: "German",
    nativeLabel: "Deutsch",
    htmlLang: "de",
    dateLocale: "de-DE",
    enabledForTranslation: true,
    publiclyLaunched: false,
    isSource: false,
  },
  {
    code: "fr",
    label: "French",
    nativeLabel: "Français",
    htmlLang: "fr",
    dateLocale: "fr-FR",
    enabledForTranslation: true,
    publiclyLaunched: false,
    isSource: false,
  },
  {
    code: "es",
    label: "Spanish",
    nativeLabel: "Español",
    htmlLang: "es",
    dateLocale: "es-ES",
    enabledForTranslation: true,
    publiclyLaunched: false,
    isSource: false,
  },
] as const;

export type LakeComoLocale = (typeof LAKE_COMO_LOCALES)[number]["code"];
export type LakeComoTranslatedLocale = Exclude<LakeComoLocale, typeof LAKE_COMO_SOURCE_LOCALE>;

const byCode = new Map(LAKE_COMO_LOCALES.map((locale) => [locale.code, locale] as const));

export function isLakeComoLocale(value: unknown): value is LakeComoLocale {
  return typeof value === "string" && byCode.has(value.toLowerCase() as LakeComoLocale);
}

export function isLakeComoTranslatedLocale(value: unknown): value is LakeComoTranslatedLocale {
  return isLakeComoLocale(value) && value !== LAKE_COMO_SOURCE_LOCALE;
}

export function lakeComoLocale(value: unknown): LakeComoLocale | null {
  return isLakeComoLocale(value) ? value.toLowerCase() as LakeComoLocale : null;
}

export function getLakeComoLocale(value: LakeComoLocale) {
  return byCode.get(value)!;
}

export const LAKE_COMO_TRANSLATED_LOCALES = LAKE_COMO_LOCALES
  .filter((locale) => locale.enabledForTranslation)
  .map((locale) => locale.code) as LakeComoTranslatedLocale[];
